/*
 *
 * MeasurementHistory constants
 *
 */

export const CREATE_MEASUREMENT_WATCHER =
  "app/MeasurementHistory/CREATE_MEASUREMENT_WATCHER"
export const CREATE_MEASUREMENT_SUCCESS =
  "app/MeasurementHistory/CREATE_MEASUREMENT_SUCCESS"
export const CREATE_MEASUREMENT_FAILED =
  "app/MeasurementHistory/CREATE_MEASUREMENT_FAILED"

export const LIST_SURVEYS_WATCHER =
  "app/MeasurementHistory/LIST_SURVEYS_WATCHER"
export const LIST_SURVEYS_SUCCESS =
  "app/MeasurementHistory/LIST_SURVEYS_SUCCESS"
export const LIST_SURVEYS_FAILED = "app/MeasurementHistory/LIST_SURVEYS_FAILED"

export const LIST_MEASUREMENTS_WATCHER =
  "app/MeasurementHistory/LIST_MEASUREMENTS_WATCHER"
export const LIST_MEASUREMENTS_SUCCESS =
  "app/MeasurementHistory/LIST_MEASUREMENTS_SUCCESS"
export const LIST_MEASUREMENTS_FAILED =
  "app/MeasurementHistory/LIST_MEASUREMENTS_FAILED"

export const DELETE_MEASURE_WATCHER =
  "app/MeasurementHistory/DELETE_MEASURE_WATCHER"
export const DELETE_MEASURE_SUCCESS =
  "app/MeasurementHistory/DELETE_MEASURE_SUCCESS"
export const DELETE_MEASURE_FAILED =
  "app/MeasurementHistory/DELETE_MEASURE_FAILED"

export const HAS_COLLABORATORS_WATCHER =
  "app/MeasurementHistory/HAS_COLLABORATORS_WATCHER"
export const HAS_COLLABORATORS_SUCCESS =
  "app/MeasurementHistory/HAS_COLLABORATORS_SUCCESS"
export const HAS_COLLABORATORS_FAILED =
  "app/MeasurementHistory/HAS_COLLABORATORS_FAILED"
